import { render, staticRenderFns } from "./Travels.vue?vue&type=template&id=ecb5260e&"
var script = {}
import style0 from "./Travels.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports